import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { FromUncertainty } from './components/FromUncertainty';
import { Framework } from './components/Framework';
import { Introducing } from './components/Introducing';
import { Problem } from './components/Problem';
import { BeforeAfter } from './components/BeforeAfter';
import { ForYou } from './components/ForYou';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Expectations } from './components/Expectations';
import { Creator } from './components/Creator';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjga9mglsbmq" />
      <main data-id="element-2" data-mp="3rc9e8848zfxr">
        <Hero data-id="element-3" data-mp="3rcj31sdk3h1v" />
        <FromUncertainty data-id="element-4" data-mp="3rbzo8kj7d8s2" />
        <Framework data-id="element-5" data-mp="3rcsyvwla8ifh" />
        <Introducing data-id="element-6" data-mp="3recdlirailf5" />
        <Problem data-id="element-7" data-mp="5ygolyg4xb6" />
        <BeforeAfter data-id="element-8" data-mp="6htjo98ovic" />
        <ForYou data-id="element-9" data-mp="4n5i12o8na1" />
        <Volumes data-id="element-10" data-mp="56mnfkhz7n0" />
        <Toolkit data-id="element-11" data-mp="7suzhf7pr6a" />
        <Bonuses data-id="element-12" data-mp="2zld0l5ad579f" />
        <Testimonials data-id="element-13" data-mp="2zlv7cvunj3vl" />
        <Offer data-id="element-14" data-mp="2zmemy5wtxg6g" />
        <Guarantee data-id="element-15" data-mp="2zmwggus3xgao" />
        <Expectations data-id="element-16" data-mp="2zng1wlgyumtg" />
        <Creator data-id="element-17" data-mp="33m5am0r27g6r" />
        <Faq data-id="element-18" data-mp="33nq73vwxp979" />
      </main>
      <FinalCta data-id="element-19" data-mp="33mym1f0yqtv8" />
      <FloatingCta data-id="element-20" data-mp="33orkw85c49so" />
      <PurchasePopup data-id="element-21" data-mp="38m1fs3bhtdnw" />
    </div>;
}